module.exports = __webpack_public_path__ + "d626f70a21bd689a3a42365b0692bb6e.png";